// extracted by mini-css-extract-plugin
module.exports = {"CameraPreview_Canvas_Square":"style_CameraPreview_Canvas_Square__jI0gu","CameraPreview_Canvas_Rectangle":"style_CameraPreview_Canvas_Rectangle__3aejN"};